import { ApiService } from '../model/Api.model';
import { AxiosInstance } from 'axios';
import { IExpenseCategory } from '../interface/Expense/IExpenseCategory';

enum ExpenseCategoryServiceEnum {
  get = "/",
  create = "/",
  update = "/",
}

export default class ExpenseCategoryService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/expense-category");
  }

  public getAll = async (): Promise<IExpenseCategory[]> => await this.GET(ExpenseCategoryServiceEnum.get, "text");
  public create = async (data: IExpenseCategory): Promise<void> => await this.POST(ExpenseCategoryServiceEnum.create, data, "text");
  public update = async (data: IExpenseCategory): Promise<void> => await this.PUT(ExpenseCategoryServiceEnum.update, data, "text");
  public getById = async (id: number): Promise<IExpenseCategory> => await this.GET(ExpenseCategoryServiceEnum.get + id, "text");
}